import { Options } from 'chartjs-plugin-datalabels/types/options';
import { Chart } from 'chart.js';

export interface IXGridChartTooltip {
	name: string;
	examples?: string[];
	influence?: number;
	satisfaction?: number;
	avgMark?: number;
}

export interface IChartPoint {
	x: number;
	y: number;
	r: number;
	label: string;
	priority: string;
}

interface IChartData {
	data: IChartPoint[];
	datalabels: Options;
}

export interface IChartDatasets {
	datasets: IChartData[];
}

export interface IXAxesMinMax {
	min: number;
	max: number;
}

export interface IChartAreaData {
	color: string;
	x: number;
	y: number;
	width: number;
	height: number;
}

export enum AlignTypes {
	left = 'left',
	right = 'right',
	start = 'start',
	center = 'center',
	end = 'end',
	bottom = 'bottom',
	top = 'top',
}

export interface IChartParams {
	minX: number;
	maxX: number;
	chart: Chart;
	chartArea: Chart.ChartArea;
	chartXRange: number;
	chartWidthPx: number;
	chartHeightPx: number;
	xRatio: number;
	yRatio: number;
}

export interface IPointSizes {
	labelWidthPX: number;
	relativeLabelWidth: number;
	relativeHalfLabelWidth: number;
	relativeLabelWidthWithOffset: number;
	relativeLabelHeight: number;
	relativeHalfLabelHeight: number;
	relativeLabelHeightWithOffset: number;
}

export interface IPointWithAlign extends IChartPoint {
	align: AlignTypes;
	isChanged?: boolean;
}

export interface IPointWithAlignAndSize extends IPointWithAlign, IPointSizes {}

export interface IPointWithLabelCoordinates extends IPointWithAlignAndSize {
	labelLeftTopX: number;
	labelLeftTopY: number;
}

export interface IPointWithCoordinates extends IPointWithLabelCoordinates {
	pointLeftTopX: number;
	pointLeftTopY: number;
}
